import script from "./ProjectHero.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHero.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHero.vue?vue&type=style&index=0&id=02ff75f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ff75f6"]])

export default __exports__